const VIDEO_CREATED = 'online_store_media_video_created/4.0';
const VIDEO_CAN_PLAY = 'online_store_media_video_canplay/3.0';
const VIDEO_PROGRESS = 'online_store_media_video_progress/3.0';

const MODEL_VIEWER_CREATED = 'online_store_media_model_viewer_created/1.0';
const MODEL_VIEWER_LOADED = 'online_store_media_model_viewer_loaded/1.0';
const MODEL_VIEWER_FAILED = 'online_store_media_model_viewer_failed/1.0';
const MODEL_VIEWER_INTERACT = 'online_store_media_model_viewer_interact/1.0';

const AR_CREATED = 'online_store_media_ar_created/1.0';
const AR_INVOKED = 'online_store_media_ar_invoked/1.0';

export {
  VIDEO_CREATED,
  VIDEO_CAN_PLAY,
  VIDEO_PROGRESS,
  MODEL_VIEWER_CREATED,
  MODEL_VIEWER_LOADED,
  MODEL_VIEWER_FAILED,
  MODEL_VIEWER_INTERACT,
  AR_CREATED,
  AR_INVOKED,
};
